import logoURL from 'assets/images/logo.png';
import { useStyletron } from 'styletron-react';

type Props = {
  height: number;
  width: number;
  clicked: () => void;
};

const Logo = ({ height, width, clicked }: Props) => {
  const [css] = useStyletron();
  return (
    <>
      <img
        className={css({
          width: `${width}px`,
          height: `${height}px`,
          borderRadius: '50%',
          cursor: 'pointer',
        })}
        src={logoURL}
        alt="Mail Chimp"
        onClick={clicked}
      />
    </>
  );
};
export default Logo;
